<template>
  <div class="container mb-20" v-if="infoMessage || errorMessage">
    <div class="m-message--error" v-if="errorMessage">
      <span role="alert" class="m-message--error__description" v-html="errorMessage"></span>
      <span class="dialog-close" v-on:click="closeMessage"></span>
    </div>
    <div class="m-message--info" v-if="infoMessage">
      <span role="alert" class="m-message--info__description">{{ infoMessage }}</span>
      <span class="dialog-close" v-on:click="closeMessage"></span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  computed: mapState({
    errorMessage: state => state.globalstate.errorMessage,
    infoMessage: state => state.globalstate.infoMessage
  }),
  watch: {
    errorMessage () {
      if (this.errorMessage !== '') {
        // scroll to messageContainer element when there is an error message
        this.$nextTick(() => this.scrollViewToMessage())
      }
    },
    infoMessage () {
      if (this.infoMessage !== '') {
        // scroll to messageContainer element when there is an info message
        this.$nextTick(() => this.scrollViewToMessage())
      }
    }
  },
  methods: {
    scrollViewToMessage () {
      const errorMessage = document.getElementsByClassName('m-message--error__description')
      const infoMessage = document.getElementsByClassName('m-message--info__description')
      if (errorMessage && errorMessage.length > 0) {
        errorMessage[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
      } else if (infoMessage && infoMessage.length > 0) {
        infoMessage[0].scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' })
      }
    },
    closeMessage () {
      this.$store.dispatch('globalstate/clearMessages')
    }
  }
}
</script>


// WEBPACK FOOTER //
// Message.vue?5c0d1daf